import apiClient from "./apiClient";

/**
 * Login
 */
export const login = async (
  username: string,
  password: string,
  codigoEmpresa: string
) => {
  const response = await apiClient.post("/auth/login", {
    username,
    password,
    codigoEmpresa
  });

  return response.data;
};

/**
 * Obtener nuevo access token usando refresh token (cookie HttpOnly)
 */
export const refresh = async () => {
  const response = await apiClient.post("/auth/refresh");
  return response.data;
};

/**
 * Seleccionar sucursal (para usuarios con varias sucursales). Devuelve nuevo token con sucursal.
 */
export const seleccionarSucursal = async (idSucursal: number) => {
  const response = await apiClient.post("/auth/seleccionar-sucursal", { idSucursal });
  return response.data;
};

/**
 * Logout
 */
export const logout = async () => {
  await apiClient.post("/auth/logout");
};